import type { ChangeEvent } from 'react';
import { useIntl } from 'react-intl';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { iconRectanglePro } from '@sorare/core/src/atoms/icons/system/iconRectanglePro.ts';
import { BodyM } from '@sorare/core/src/atoms/typography';
import { Switch } from '@sorare/core/src/components/search/Switch';
import { useLoggedCallback } from '@sorare/core/src/hooks/useLoggedCallback';
import { useVirtualToggle } from '@sorare/core/src/hooks/useVirtualToggle';
import { useVirtualToggleManager } from '@sorare/core/src/hooks/useVirtualToggleManager';
import { useEvents } from '@sorare/core/src/lib/events/useEvents';
import type { FilterWidget } from '@sorare/core/src/lib/filters';
import { VIRTUAL_TOGGLE_FILTERS } from '@sorare/core/src/lib/filters';

import { Toggle } from '#src/searchCards/Toggle/index.tsx';

const FILTER = VIRTUAL_TOGGLE_FILTERS.notInLineupFilter;

const Filter = () => {
  const { formatMessage } = useIntl();
  const track = useEvents();
  const setVirtualToggle = useVirtualToggleManager();
  const { currentRefinement } = useVirtualToggle<boolean>({
    name: FILTER.name,
  });

  const loggedHandleChange = useLoggedCallback<ChangeEvent<HTMLInputElement>>(
    event => {
      const newValue = event.target.checked;
      setVirtualToggle({
        [FILTER.name]: newValue,
      });
      track('Use Market Filter', {
        filterName: FILTER.trackingName,
        filterValue: newValue.toString(),
      });
    }
  );

  return (
    <Toggle icon={<FontAwesomeIcon icon={iconRectanglePro} />}>
      <Switch
        checked={!!currentRefinement}
        onChange={loggedHandleChange}
        label={<BodyM bold>{formatMessage(FILTER.label!)}</BodyM>}
      />
    </Toggle>
  );
};

export const widget: FilterWidget = {
  key: FILTER.name,
  type: 'virtualToggle',
  filter: FILTER,
  Component: Filter,
};
